import { Component, EventEmitter, Input, OnChanges, Output, SimpleChanges } from '@angular/core';
import { PCTableInputModel, PCTableOutputModel } from '../../models/pc-table-input-model';

@Component({
  selector: 'app-pcsuccess-modal',
  templateUrl: './pcsuccess-modal.component.html',
  styleUrls: ['./pcsuccess-modal.component.css']
})
export class PCSuccessModalComponent implements OnChanges {

  @Input() showModal?: boolean;

  @Output() parentAction = new EventEmitter<PCTableOutputModel>();

  ngOnChanges(changes: SimpleChanges) {
    if (changes && changes['showModal'] && changes['showModal'].currentValue !== undefined) {

      if (this.showModal == true) {
        setTimeout(() => {
          this.parentAction.next(new PCTableOutputModel('Successed',undefined));
        }, 1 * 1000);
      }

    }
  }

}
